export enum Colors {
  PURPLE = 'purple',
  RED = 'red',
  GREEN = 'green',
  BLUE = 'blue',
  YELLOW = 'yellow',
  GRAY = 'gray',
}